import { useAppState, useUserAppState } from './useAppState.js';

/**
 * @internal
 */
export type UseAppStateValueResult<T> = {
  value: T | undefined;
  isLoading: boolean;
};

/**
 * Read-only shorthand for `useAppState`.
 *
 * Must be used inside an `<AppStateProvider scope="app">`.
 * @internal
 */
export function useAppStateValue<T = unknown>(
  key: string,
): UseAppStateValueResult<T> {
  const { value, isLoading } = useAppState<T>(key);
  return { value, isLoading };
}

/**
 * @internal
 */
export type UseUserAppStateValueResult<T> = {
  value: T | undefined;
  isLoading: boolean;
};

/**
 * Read-only shorthand for `useUserAppState`.
 *
 * Must be used inside an `<AppStateProvider scope="user">`.
 * @internal
 */
export function useUserAppStateValue<T = unknown>(
  key: string,
): UseUserAppStateValueResult<T> {
  const { value, isLoading } = useUserAppState<T>(key);
  return { value, isLoading };
}
